import { render, staticRenderFns } from "./DialogConfirm.vue?vue&type=template&id=3e7bf04a&scoped=true&"
import script from "./DialogConfirm.vue?vue&type=script&lang=ts&"
export * from "./DialogConfirm.vue?vue&type=script&lang=ts&"
import style0 from "./DialogConfirm.vue?vue&type=style&index=0&id=3e7bf04a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e7bf04a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VImg,VRow})
